<template>
  <div>
    <b-loading v-model="loading" />
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <div>
            <p class="title">
              Services
            </p>

            <p class="heading">
              <span v-if="loading">Loading...</span>
              <span v-else-if="!servicesCount">No Services Set. Please add one.</span>
              <span v-else>{{servicesCount}} services available</span>
            </p>
          </div>
        </div>
      </div>

      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <b-button @click="showCreateServiceModal = true;"
                      type="is-primary"
                      size="is-small"
                      icon-left="plus">
              Service
            </b-button>

            <b-button @click="() => executeCron('fetchPicksFromTSS')" size="is-small">Fetch Pending</b-button>
            <b-button @click="() => executeCron('fetchRecordFromTSS')" size="is-small">Fetch Records</b-button>

            <b-button @click="sendPicksAlert"
                      :disabled="!selected.length"
                      size="is-small"
                      icon-right="send">
              Send Alert
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="showCreateServiceModal" @close="showCreateServiceModal = false">
      <div class="box">
        <service-create @updated="serviceUpdated" />
      </div>
    </b-modal>

    <b-modal v-model="showCronOutput" @close="showCronOutput = false">
      <pre><code>{{cronOutput}}</code></pre>
    </b-modal>

    <div v-for="(serviceData, serviceCode) in services" :key="serviceCode" class="mb-3">
      <service @selected="serviceSelected"
               @unselected="serviceUnselected"
               @removedService="serviceRemoved"
               :code="serviceCode"
               :data="serviceData"
               :all-codes="allCodes" />
    </div>
  </div>
</template>

<script>
import {getServices, logout, sendPicksAlert} from '@/utils/api';
import Service from '@/components/admin/Service';
import ServiceCreate from '@/components/admin/ServiceCreate';

export default {
  components: {
    Service,
    ServiceCreate
  },
  data() {
    return {
      showCreateServiceModal: false,
      services: {},
      loading: true,
      selected: [],
      showCronOutput: false,
      cronOutput: '',
    }
  },
  mounted() {
    getServices()
      .then(async res => {
        if (!res.ok) {
          this.$buefy.toast.open(`error: ${res.status}: ${res.statusText}`);
          if (res.status === 403) {
            await logout({isAdmin: true});
          }

          return this.$router.push('/login');
        }

        this.services = await res.json();
      })
      .finally(() => {
        this.loading = false;
      })
  },
  methods:{
    executeCron: async function (operation) {
      this.loading = true;
      let res = await fetch(`/api/admin/${operation}.php`); //fetchPicksFromTSS

      if (!res.ok) {
        console.error(await res.json());
        this.loading = false;
        return this.$buefy.toast.open({
          type: 'is-danger',
          message: `${res.status}:${res.statusText}`
        });
      }

      let output = await res.json();
      this.cronOutput = output.out;
      this.showCronOutput = true;
      this.loading = false;
    },
    sendPicksAlert: async function () {
      this.loading = true;
      let res = await sendPicksAlert(this.selected);
      let toastSettings = res.ok ?
          {message: 'Alert Sent', type: 'is-success'} :
          {message: 'Alert Failed', type: 'is-danger'}

      this.$buefy.toast.open(toastSettings);
      this.loading = false;

      console.log(await res.json());
    },
    serviceSelected: function (code) {
      this.selected = [...this.selected, code];
    },
    serviceUnselected: function (code) {
      this.selected = this.selected.filter(selectedCode => selectedCode !== code);
    },
    serviceUpdated: function (e) {
      this.showCreateServiceModal = false;
      this.services = e;
    },
    serviceRemoved: function (e) {
      let filteredServices = {...this.services};

      delete filteredServices[e];

      this.services = filteredServices;
    }
  },
  computed: {
    servicesCount: function () {
      return Object.keys(this.services).length;
    },
    allCodes: function () {
      return Object.keys(this.services);
    }
  }
}
</script>

<style scoped>

</style>